import React from 'react';

import sy from '~/styles';
import {Dialog, Checkbox, Pressable, Text} from '~/components/controls';
import {useDispatch, useSelector} from '~/lib/hooks';
import {setUserSettings} from '~/actions';
import {user as userApi} from '~/api/private';
import PropTypes from 'prop-types';

const CancelRobTaskDialog = ({
  visible,
  onCancel,
  onDismiss,
  PressableComponent = Pressable,
}) => {
  const dispatch = useDispatch();
  const user_settings = useSelector((state) => state.user_settings);
  const neverShowAgain = user_settings?.never_show_rob_task_cancel_dialog;

  return (
    <Dialog
      visible={visible}
      title="Item laten vervallen?"
      buttons={[
        {text: 'Annuleren', onPress: onDismiss},
        {
          text: 'Vervallen',
          textStyle: {color: '#972727'},
          onPress: async () => {
            if (neverShowAgain) {
              await userApi.update_settings({
                ...user_settings,
                never_show_rob_task_cancel_dialog: neverShowAgain,
              });
            }

            onCancel();
          },
        },
      ]}
      onDismiss={onDismiss}>
      <PressableComponent
        style={[sy['py-4'], sy['gap-4'], sy['flex-row'], sy['items-center']]}
        onPress={() =>
          dispatch(
            setUserSettings({
              never_show_rob_task_cancel_dialog: !neverShowAgain,
            }),
          )
        }>
        <Checkbox checked={neverShowAgain} />
        <Text>Niet meer tonen</Text>
      </PressableComponent>
    </Dialog>
  );
};
CancelRobTaskDialog.propTypes = {
  PressableComponent: PropTypes.elementType,
  visible: PropTypes.any,
  onCancel: PropTypes.any,
  onDismiss: PropTypes.any,
};

export default CancelRobTaskDialog;
